import { connect, Dispatch } from 'react-redux';

import { Action } from '../../actions';
import {
    changeMarketerAccessCell,
    changeMarketerProduct
} from '../../actions/marketers/marketerCard';
import {
    MarketerProductAccessCell,
    MarketerProductAccessCellProps
} from '../../components/MarketerProductAccessCell/MarketerProductAccessCell';
import { MarketerProductsCellItem } from '../../typings/marketers';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type OwnProps = MarketerProductsCellItem;

type StateProps = TStateProps<MarketerProductAccessCellProps, OwnProps>;
type DispatchProps = TDispatchProps<MarketerProductAccessCellProps>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const {
        marketerCard: { pageStatus },
        grid: { isGridScrolling }
    } = state;

    return {
        product: ownProps,
        pageStatus,
        isGridScrolling
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        changeMarketerProduct: (product: MarketerProductsCellItem) =>
            dispatch(changeMarketerProduct(product)),
        changeMarketerAccessCell: (product: MarketerProductsCellItem) =>
            dispatch(changeMarketerAccessCell(product))
    };
};

export const MarketerProductAccessCellContainer = connect<
    StateProps,
    DispatchProps
>(
    mapStateToProps,
    mapDispatchToProps
)(MarketerProductAccessCell);
